import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { AuthService } from "./auth.service";

/**
 * Intercepts all HTTP requests and automatically attaches our bearer token to it.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!req.url.includes(environment.ponderBaseUrl)) {
            // Don't include the bearer token on requests to third-parties.
            return next.handle(req);
        }

        const token = inject(AuthService)?.superSecretGetSessionDontUseMeUnlessYouHaveToOk()?.token;

        if (!token || (token === "undefined")) {
            // We are not currently authenticated.
            return next.handle(req);
        }

        const modifiedReq = req.clone({
            headers: req.headers.set("Authorization", `Bearer ${token}`)
        });

        return next.handle(modifiedReq);
    }
}